import { differenceInMilliseconds } from 'date-fns';
import './countdownclock.css';
import * as utils from '../utils/utils.js';

export default class CountdownClock {
    constructor($scope, $interval) {
        this.$interval = $interval;
        this.$scope = $scope;
        this.siteSettings = siteSettings;

        this.displayClock = false;

        // Context object for the graphics
        this.c = {
            context: {},
            values: {},
            times: {}
        };

        // Get 2D contexts
        this.c.context.seconds = document.getElementById('seconds-canvas').getContext('2d');
        this.c.context.minutes = document.getElementById('minutes-canvas').getContext('2d');
        this.c.context.hours = document.getElementById('hours-canvas').getContext('2d');
        this.c.context.days = document.getElementById('days-canvas').getContext('2d');

        this.initCountdown();
    }

    calculateJoinTime() {
        this.joinInMS = differenceInMilliseconds(
            utils.getDateFromUTCString(this.event.startTime),
            new Date()
        );
        if (this.event.useCustomCDSwitchover && this.event.customCDSwitchOverTime) {
            this.customJoinInMS = differenceInMilliseconds(
                utils.getDateFromUTCString(this.event.customCDSwitchOverTime),
                new Date()
            );
        }
        this.startDateLocal = utils.parseDateAtTimeToLocale(this.event.startTime);

        const noOfViewersInt = parseInt(this.$scope.$parent.ctrl.noofviewers);
        if (
            this.$scope.$parent.ctrl.showviewcount === 'true' &&
            this.$scope.event.viewingState < 2 &&
            noOfViewersInt > 0
        ) {
            this.startDateLocal += ' | ' + noOfViewersInt.toLocaleString() + ' waiting';
        }
    }

    initCountdown() {
        this.foregroundColor = this.findOutColor();
        this.counter = this.$interval(() => {
            if (this.$scope.event !== undefined && this.event === undefined) {
                this.event = this.$scope.event;
                this.calculateJoinTime();
            }
            if (this.event !== undefined && this.joinInMS > 0) this.updateCounter();
        }, 1000);
    }

    updateCounter() {
        this.event = this.$scope.event;
        this.calculateJoinTime();

        this.c.times.days = Math.floor(this.joinInMS / (1000 * 60 * 60 * 24));
        this.c.times.hours = Math.floor((this.joinInMS % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.c.times.minutes = Math.floor((this.joinInMS % (1000 * 60 * 60)) / (1000 * 60));
        this.c.times.seconds = Math.floor((this.joinInMS % (1000 * 60)) / 1000);

        if (this.c.times.days < 10) {
            this.c.times.days = '0' + this.c.times.days;
        }
        if (this.c.times.hours < 10) {
            this.c.times.hours = '0' + this.c.times.hours;
        }
        if (this.c.times.minutes < 10) {
            this.c.times.minutes = '0' + this.c.times.minutes;
        }
        if (this.c.times.seconds < 10) {
            this.c.times.seconds = '0' + this.c.times.seconds;
        }

        let daysElem = document.querySelector('#days');
        let hoursElem = document.querySelector('#hours');
        let minutesElem = document.querySelector('#minutes');
        let secondsElem = document.querySelector('#seconds');

        if (this.joinInMS <= 86400000) utils.hideElement(daysElem);
        else utils.showElement(daysElem);

        if (this.joinInMS <= 3600000) utils.hideElement(hoursElem);
        else utils.showElement(hoursElem);

        if (this.joinInMS <= 60000) utils.hideElement(minutesElem);
        else utils.showElement(minutesElem);

        if (this.joinInMS <= 1000) utils.hideElement(secondsElem);
        else utils.showElement(secondsElem);

        // Act to show video if our join time is approaching within a couple of seconds u
        if (this.joinInMS < 2000 || (this.customJoinInMS && this.customJoinInMS < 2000)) {
            // Stop countdown
            this.$interval.cancel(this.counter);
            this.counter = undefined;
            this.displayClock = false;

            // If we are on the video page, initialize video player, user interaction and so on
            if (this.$scope.watchService !== undefined) {
                this.$scope.watchService.videoSwitchedFromCountdown = true;
                this.$scope.watchService.currentView = this.$scope.watchService.CURRENT_VIEW.video;
                this.$scope.watchService.prepareVideoView();
            }
        } else this.render(); // Redraw circles!
    }

    findOutColor() {
        let secondsTextElem = document.querySelector('#count-sec span');
        if (secondsTextElem !== undefined && secondsTextElem !== null && window.getComputedStyle)
            return window.getComputedStyle(secondsTextElem).getPropertyValue('color');

        return '#FFF';
    }

    // Convert radians to degrees
    deg(d) {
        return (Math.PI / 180) * d - (Math.PI / 180) * 90;
    }

    render() {
        this.c.context.seconds.clearRect(0, 0, 100, 100);
        this.c.context.seconds.beginPath();
        this.c.context.seconds.strokeStyle = this.foregroundColor;
        this.c.context.seconds.arc(
            50,
            50,
            40,
            this.deg(6 * (60 - this.c.times.seconds)),
            this.deg(360)
        );
        /* If one wants to move counter clockwise 
        this.c.context.seconds.arc(50, 50, 40, this.deg(0), this.deg(6 * (this.c.times.seconds-1))); */
        this.c.context.seconds.lineWidth = 3;
        this.c.context.seconds.lineCap = 'rect';
        this.c.context.seconds.stroke();

        this.c.context.minutes.clearRect(0, 0, 100, 100);
        this.c.context.minutes.beginPath();
        this.c.context.minutes.strokeStyle = this.foregroundColor;
        this.c.context.minutes.arc(
            50,
            50,
            40,
            this.deg(6 * (60 - this.c.times.minutes)),
            this.deg(360)
        );
        this.c.context.minutes.lineWidth = 3;
        this.c.context.minutes.lineCap = 'rect';
        this.c.context.minutes.stroke();

        this.c.context.hours.clearRect(0, 0, 100, 100);
        this.c.context.hours.beginPath();
        this.c.context.hours.strokeStyle = this.foregroundColor;
        this.c.context.hours.arc(
            50,
            50,
            40,
            this.deg(15 * (24 - this.c.times.hours)),
            this.deg(360)
        );
        this.c.context.hours.lineWidth = 3;
        this.c.context.hours.lineCap = 'rect';
        this.c.context.hours.stroke();

        this.c.context.days.clearRect(0, 0, 100, 100);
        this.c.context.days.beginPath();
        this.c.context.days.strokeStyle = this.foregroundColor;
        this.c.context.days.arc(50, 50, 40, this.deg(360 - this.c.times.days), this.deg(360));
        this.c.context.days.lineWidth = 3;
        this.c.context.days.lineCap = 'rect';
        this.c.context.days.stroke();

        this.displayClock = true;
    }
}
